import {
    pxToRem,
    pxArrayToRem,
    labelClassName,
    type StyleRule,
} from '@archipro-design/aria';

export const ProfessionalsWrapper: StyleRule = () => ({
    marginBottom: pxToRem(240),
});

export const Header: StyleRule = ({ theme }) => ({
    fontSize: pxToRem(18),
    fontWeight: '500',
    margin: pxArrayToRem([0, 12, 12, 12]),

    [theme.screen.min.tablet]: {
        fontSize: pxToRem(22),
        marginLeft: pxToRem(922),
        padding: pxArrayToRem([0, 0, 60, 0]),
        marginBottom: 0,
        whiteSpace: 'pre-line',
        textAlign: 'left',
        letterSpacing: theme.siteVariables.letterSpacingSmall,
    },
});

export const LoadMoreButton: StyleRule = ({
    theme: { siteVariables, screen },
}) => ({
    padding: pxArrayToRem([15, 42.5]),
    textTransform: 'uppercase',
    outline: `1px solid ${siteVariables.colorScheme.default?.foreground}`,
    width: '100%',
    margin: pxArrayToRem([0, 19, 35, 19]),
    [`& .${labelClassName}`]: {
        fontSize: pxToRem(20),
        letterSpacing: siteVariables.letterSpacingMedium,
        fontWeight: 500,
    },
    [screen.tablet]: {
        width: 'auto',
        marginLeft: pxToRem(917),
        marginTop: pxToRem(52),
        padding: pxArrayToRem([24, 42.5]),
        [`& .${labelClassName}`]: {
            fontSize: pxToRem(16),
            letterSpacing: siteVariables.letterSpacingMedium,
            fontWeight: 500,
        },
    },
});

export const TileCutOff: StyleRule = () => ({
    height: pxToRem(0),
    overflow: 'hidden',
});

export const Tile: StyleRule = ({ theme: { screen } }) => ({
    marginBottom: pxToRem(50),
    [screen.tablet]: {
        marginBottom: pxToRem(0),
    },
});
